import React from 'react';
import { FiLock as Lock, FiArrowRight as ArrowRight } from 'react-icons/fi';

interface UpgradeBannerProps {
  onUpgradeClick: () => void;
}

const UpgradeBanner: React.FC<UpgradeBannerProps> = ({ onUpgradeClick }) => {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-blue-600 dark:from-purple-700 dark:to-blue-700">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex items-start space-x-3 flex-1">
            <Lock className="w-5 h-5 text-white flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-white text-sm sm:text-base font-medium">
                You are seeing demo data. Only the Assessment functionality is available.
              </p>
              <p className="text-white text-xs sm:text-sm mt-1 opacity-90">
                Your organization is in a Lens trial period, get access to full functionality
              </p>
            </div>
          </div>
          <button
            onClick={onUpgradeClick}
            className="flex-shrink-0 inline-flex items-center px-6 py-2 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:bg-gray-50 dark:bg-gray-100 dark:hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-600 focus:ring-white transition-colors ml-4 mt-2 sm:mt-0 shadow-md"
          >
            Log In / Register
            <ArrowRight className="ml-2 w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeBanner;
